export const ECOREBATES_GET_ERROR = 'ECOREBATES_GET_ERROR';
export const ECOREBATES_GET_REQUEST = 'ECOREBATES_GET_REQUEST';
export const ECOREBATES_GET_SUCCESS = 'ECOREBATES_GET_SUCCESS';
